import { Box, Stack } from "@mui/material";
import parlors from "goi_common/src/constants/parlors_detail.json";

import {
  ParlorRegionHeadSection,
  ATypeCardView,
  BTypeBreadCrumb,
  ATypeRegionHead,
  ATypeCTA,
  ATypeParlorList,
  FUNERAL_SIDO,
  FUNERAL_SIGUNGU,
  ParlorDetailProps,
  numberToLocalString,
  GOI_WEB_URL,
  buildParlorRegionPageSchema,
  ParlorRegionFAQ,
  RichSearch,
} from "goi_common";
import { parlorRegion } from "@/constants/parlorRegion";
import { GetStaticPaths, GetStaticProps } from "next";
import Head from "next/head";

// Path 로직 안내
// FUNERAL_SIDO, SIGUNGU의 key로 path 설정.
//
// 1. getStaticPaths 내 key 받아서 params로 넘기게 변경
// 2. getByValue key 넣어서 value를 나타내는 함수로 변경
// 3. getStaticProps 내 props sido, sidoName, sigungu, sigunguName 변경

const { regionColor, targetSidos } = parlorRegion;

export const getStaticPaths: GetStaticPaths = async () => {
  const sidoList = Array.from(FUNERAL_SIDO.keys()).filter((res) =>
    targetSidos.includes(String(res))
  );

  const sidoPath = sidoList.map((sido) => {
    return {
      params: {
        code: String(sido),
      },
    };
  });

  const sigunguPaths = Array.from(FUNERAL_SIDO)
    .filter(([key, val]) => targetSidos.includes(String(key)))
    .map(([key, val]) => {
      const sigungus = FUNERAL_SIGUNGU.get(key);
      if (sigungus) {
        return Array.from(sigungus.keys()).map((sigungu) => {
          return {
            params: {
              code: `${key}-${sigungu}`,
            },
          };
        });
      }
    })
    .filter((i) => i != null);

  return {
    paths: sidoPath.concat(sigunguPaths?.flat() as Array<any>),
    fallback: false,
  };
};

function getByValue(map: Map<number, any>, searchValue: any) {
  for (const [key, value] of map.entries()) {
    if (key === searchValue) return value;
  }
}

export const getStaticProps: GetStaticProps = async ({ params }) => {
  const code = params?.code as string;

  if (code.includes("-")) {
    const [sido, sigungu] = code.split("-");
    const sidoName = getByValue(FUNERAL_SIDO, Number(sido));
    const sigunguName = getByValue(
      FUNERAL_SIGUNGU.get(Number(sido)) as any,
      Number(sigungu)
    );

    const regionParlors = parlors.filter(
      (p) => String(p.sigungu) === String(sigungu)
    );

    const 가족장 = Number(
      (
        regionParlors.reduce((prev, curr) => {
          return curr.expected_charge_sum["가족장"] + prev;
        }, 0) / regionParlors.length
      ).toFixed(0)
    ).toLocaleString();
    const 무빈소장 = Number(
      (
        regionParlors.reduce((prev, curr) => {
          return curr.expected_charge_sum["무빈소"] + prev;
        }, 0) / regionParlors.length
      ).toFixed(0)
    ).toLocaleString();
    const 일반장 = Number(
      (
        regionParlors.reduce((prev, curr) => {
          return curr.expected_charge_sum["일반장"] + prev;
        }, 0) / regionParlors.length
      ).toFixed(0)
    ).toLocaleString();

    let parlorsString = "";
    regionParlors.map((p: any) => {
      parlorsString += `${p.companyname} ${numberToLocalString(
        p.binsos[0].charge
      )}원, `;
    });

    const description = `${sigunguName} 지역 장례식장 전체 비교하기 조문객 100
    명 기준 1일 빈소 비용 및 기타 비용. ${sigunguName}포함한 다른 지
    역의 장례식장들과 비교 추천 | ${parlorsString}...`;

    return {
      props: {
        regionParlors,
        expectedParlorPrice: { 무빈소장, 가족장, 일반장 },
        sidoName: sidoName,
        sido: sido,
        sigunguName: sigunguName,
        sigungu: sigungu,
        isSigungu: true,
        pageDescription: description,
        pageKeywords: `${sigunguName}장례식장, ${sigunguName}장례식장 추천, ${sigunguName}장례식장 비용, ${sigunguName}장례식장 평균 예상 비용, ${sigunguName} 무빈소, ${sigunguName} 가족장, ${sigunguName}`,
        pageOgTitle: `${sidoName} ${sigunguName} 지역 장례식장 추천, 비교 | 대구경북장례정보포털`,
        pageOgDescription: description,
        pageOgImage: regionParlors[0]?.images[0]?.url || "",
      },
    };
  } else {
    const sidoName = getByValue(FUNERAL_SIDO, Number(code));

    const regionParlors = parlors.filter((p) => p.sido === String(code));

    const 가족장 = Number(
      (
        regionParlors.reduce((prev, curr) => {
          return curr.expected_charge_sum["가족장"] + prev;
        }, 0) / regionParlors.length
      ).toFixed(0)
    ).toLocaleString();
    const 무빈소장 = Number(
      (
        regionParlors.reduce((prev, curr) => {
          return curr.expected_charge_sum["무빈소"] + prev;
        }, 0) / regionParlors.length
      ).toFixed(0)
    ).toLocaleString();
    const 일반장 = Number(
      (
        regionParlors.reduce((prev, curr) => {
          return curr.expected_charge_sum["일반장"] + prev;
        }, 0) / regionParlors.length
      ).toFixed(0)
    ).toLocaleString();

    let parlorsString = "";
    regionParlors.map((p: any) => {
      parlorsString += `${p.companyname} ${numberToLocalString(
        p.binsos[0].charge
      )}원, `;
    });

    const description = `${sidoName} 지역 장례식장 전체 비교하기 조문객 100
    명 기준 1일 빈소 비용 및 기타 비용. ${sidoName}포함한 다른 지
    역의 장례식장들과 비교 추천 | ${parlorsString}...`;

    return {
      props: {
        regionParlors,
        expectedParlorPrice: { 무빈소장, 가족장, 일반장 },
        sidoName: sidoName,
        sido: code,
        isSigungu: false,
        pageDescription: description,
        pageKeywords: `${sidoName}장례식장, ${sidoName}장례식장 추천, ${sidoName}장례식장 비용, ${sidoName}장례식장 평균 예상 비용, ${sidoName} 무빈소, ${sidoName} 가족장, ${sidoName}`,
        pageOgTitle: `${sidoName} 지역 장례식장 추천, 비교 | 대구경북장례정보포털`,
        pageOgDescription: description,
        pageOgImage: regionParlors[0]?.images[0]?.url || "",
      },
    };
  }
};

export default function ParlorSlugTypePage({
  regionParlors,
  expectedParlorPrice,
  pageOgTitle,
  sido,
  sidoName,
  sigungu,
  sigunguName,
  isSigungu,
}: {
  regionParlors: Array<ParlorDetailProps>;
  expectedParlorPrice: { 무빈소장: number; 가족장: number; 일반장: number };
  pageOgTitle: string;
  sido: string;
  sidoName: string;
  sigungu?: string;
  sigunguName?: string;
  isSigungu: boolean;
}) {
  if (sigungu === "37360") {
    return <></>;
  }
  if (regionParlors.length === 0) {
    return <></>;
  }

  const parlorRegionPageSchema = buildParlorRegionPageSchema(regionParlors, {
    regionText: `${sidoName}${isSigungu && sigunguName ? ` ${sigunguName}` : ""}`,
    itemUrlBuilder: (id) =>
      `https://dggb-portal.funeralblog.co.kr/funeral-places/${id}/`,
  });

  return (
    <>
      <Head>
        <title>{pageOgTitle}</title>
      </Head>
      <RichSearch data={parlorRegionPageSchema} />
      <ParlorRegionHeadSection
        breadCrumb={
          <BTypeBreadCrumb
            firstItem={{
              text: `장례식장 추천`,
              href: `${GOI_WEB_URL}?utm_source=dogsound` + "/match/request/?utm_source=dogsound",
              event: {
                domain: "dggb",
                path: "price",
                trigger_and_target: "br_crumb_mth_req",
              },
            }}
            secondItem={{
              text: `${sidoName} 장례식장`,
              href: `/price/${sido}/`,
              event: {
                domain: "dggb",
                path: "price",
                trigger_and_target: "br_crumb_sido_prlr_list",
              },
            }}
            thirdItem={
              isSigungu
                ? {
                    text: `${sigunguName} 장례식장`,
                    href: `/price/${sido}-${sigungu}/`,
                    event: {
                      domain: "dggb",
                      path: "price",
                      trigger_and_target: "br_crumb_sigungu_prlr_list",
                    },
                  }
                : undefined
            }
            goiHomeEvent={{
              domain: "dggb",
              path: "price",
              trigger_and_target: "br_crumb_goi_home",
            }}
          />
        }
        title={
          <ATypeRegionHead
            regionParlors={regionParlors}
            sidoName={sidoName}
            sigunguName={sigunguName}
            expectedParlorPrice={expectedParlorPrice}
          />
        }
        ctaList={[]}
      />

      <Stack
        style={{ background: regionColor.c100 }}
        padding="20px"
        marginBottom="40px"
      >
        <ATypeCTA
          mainColor={regionColor}
          sidoName={sidoName}
          sigunguName={sigunguName}
          event={{
            domain: "dggb",
            path: "price",
            trigger_and_target: "CTA_uv_mth_req",
          }}
        />
      </Stack>

      <ATypeParlorList
        sido={sido}
        sigungu={sigungu}
        title={`${sidoName} ${sigunguName ? " " + sigunguName : ""} 장례식장`}
        hasParlorsLengthInfo={true}
        CardViewType={(res) => (
          <ATypeCardView
            key={res.companyname}
            name={res.companyname}
            href={`/funeral-places/${res.id}/`}
            descriptions={[
              `빈소 평균 비용 : ${Number(
                res.binso_average_charge
              ).toLocaleString()}원`,
            ]}
            imgSrc={res.images[0] ? res.images[0].url : ""}
            event={{
              domain: "dggb",
              path: "price",
              trigger_and_target: "uv_sigun_prlr_detail",
            }}
          />
        )}
      />
      <Box padding="20px 0 " />
      {isSigungu && (
        <ATypeParlorList
          sido={sido}
          title={`${sidoName} 장례식장`}
          hasParlorsLengthInfo={true}
          CardViewType={(res) => (
            <ATypeCardView
              key={res.companyname}
              name={res.companyname}
              href={`/funeral-places/${res.id}/`}
              descriptions={[
                `빈소 평균 비용 : ${Number(
                  res.binso_average_charge
                ).toLocaleString()}원`,
              ]}
              imgSrc={res.images[0] ? res.images[0].url : ""}
              event={{
                domain: "dggb",
                path: "price",
                trigger_and_target: "uv_sido_prlr_detail",
              }}
            />
          )}
        />
      )}

      <ParlorRegionFAQ />
    </>
  );
}
